// import React, { useEffect, useRef } from 'react'
// import watsIcon from '../assest/home/5357b4eb16238760df0ba166628f1cee41086e44.png';
// import { Link } from 'react-router-dom';
// import styleCompanys from '../css/backgrounds/comCreated.module.css'
// import stylePrem from '../css/backgrounds/primResidency.module.css';
// import styleMark from '../css/backgrounds/markService.module.css';
// import styleAcc from '../css/backgrounds/accServices.module.css';
// import styleProg from '../css/backgrounds/programming.module.css';
// // Import Swiper ومكوناته
// import { Swiper, SwiperSlide } from 'swiper/react';
// import { Autoplay, Pagination, Navigation } from 'swiper/modules';
// import 'swiper/css';
// import 'swiper/css/pagination';
// import 'swiper/css/navigation';

// function AllServices() {
//     const serviceRefs = useRef([]);

//     useEffect(() => {
//         try {
//             const observer = new IntersectionObserver(
//                 (entries) => {
//                     entries.forEach((entry) => {
//                         if (entry.isIntersecting) {
//                             entry.target.classList.add('animate-in');
//                             observer.unobserve(entry.target);
//                         }
//                     });
//                 },
//                 {
//                     threshold: 0.1,
//                     rootMargin: '0px 0px -50px 0px'
//                 }
//             );

//             serviceRefs.current.forEach((ref) => {
//                 if (ref) observer.observe(ref);
//             });

//             return () => {
//                 serviceRefs.current.forEach((ref) => {
//                     if (ref) observer.unobserve(ref);
//                 });
//             };
//         } catch (err) {
//             console.log(err,'allservices')
//         }
//     }, []);

//     const addToRefs = (el, index) => {
//         try {
//             if (el && !serviceRefs.current.includes(el)) {
//                 serviceRefs.current[index] = el;
//             }
//         } catch (err) {
//             console.log(err,'allservices')
//         }
//     };

//     return (
//         <div className="services-container">
//             <Swiper
//                 modules={[Autoplay, Pagination, Navigation]}
//                 spaceBetween={20}
//                 slidesPerView={1}
//                 autoplay={{
//                     delay: 3000,
//                     disableOnInteraction: false,
//                 }}
//                 pagination={{
//                     clickable: true,
//                 }}
//                 navigation={{
//                     nextEl: '.swiper-button-next',
//                     prevEl: '.swiper-button-prev',
//                 }}
//                 breakpoints={{
//                     640: { slidesPerView: 2 },
//                     768: { slidesPerView: 3 },
//                     1024: { slidesPerView: 4 }
//                 }}
//             >
//                 {/* أزرار التنقل */}
//                 <div className="swiper-button-prev"></div>
//                 <div className="swiper-button-next"></div>

//                 <SwiperSlide>
//                     <div>
//                     <div className="services-name">
//                         <div className='training' ref={(el) => addToRefs(el, 0)}>
//                             <h1>خدمة التدريب والتأهيل</h1>
//                             <div>
//                                 <Link to='/services/TrainQualif'>التفاصيل</Link>
//                                 <span><img loading='lazy' src={watsIcon} alt="Icon" /> &nbsp;
//                                         <Link to='https://wa.me/+966561103887?text= السلام عليكم. اريد استفسر عن خدمة التدريب والتاهيل'>أطلب الان</Link>
//                                 </span>
//                             </div>
//                         </div>
//                     </div>
//                         <div className="services-name">
//                             <div className='eng-consultation' ref={(el) => addToRefs(el, 1)}>
//                                 <h1>خدمات الاستشارات الهندسية</h1>
//                                 <div>
//                                     <Link to={'/services'}>التفاصيل</Link>
//                                     <span><img loading='lazy' src={watsIcon} alt="Icon" /> &nbsp;
//                                         <Link to='https://wa.me/+966561103887?text=السلام عليكم. اريد استفسر عن خدمة هندسية'>أطلب الان</Link>
//                                     </span>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </SwiperSlide>
//                 <SwiperSlide>
//                     <div>
//                     <div className="services-name">
//                         <div className='health-Insurance' ref={(el) => addToRefs(el, 2)}>
//                             <h1>خدمات التأمين الصحي الشامل</h1>
//                             <div>
//                                 <span><Link to='/services/medicalservices'>التفاصيل</Link></span>
//                                 <span><img loading='lazy' src={watsIcon} alt="Icon" /> &nbsp;
//                                         <Link to='https://wa.me/+966561103887?text=السلام عليكم. عندس استفسار عن خدمات التامين الصحي الشامل'>أطلب الان</Link>
//                                 </span>
//                             </div>
//                         </div>
//                     </div>
//                     <div className="services-name">
//                         <div className='saber-service' ref={(el) => addToRefs(el, 3)}>
//                             <h1>خدمات سابر</h1>
//                             <div>
//                                 <span><Link to='/services/saberservices'>التفاصيل</Link></span>
//                                 <span><img loading='lazy' src={watsIcon} alt="Icon" /> &nbsp;
//                                         <Link to='https://wa.me/+966561103887?text=السلام عليكم. عندس استفسار عن خدمات سابر'>أطلب الان</Link>
//                                 </span>
//                             </div>
//                         </div>
//                     </div>
//                     </div>
//                 </SwiperSlide>
//                 <SwiperSlide>
//                     <div>
//                         <div className="services-name">
//                             <div className='ministry-interior' ref={(el) => addToRefs(el, 4)}>
//                                 <h1>خدمات وزارة الداخلية</h1>
//                                 <div>
//                                     <span>التفاصيل</span>
//                                     <span><img loading='lazy' src={watsIcon} alt="Icon" /> &nbsp;
//                                         <Link to='https://wa.me/+966561103887?text=السلام عليكم. اريد استفسر عن خدمات وازارة الداخلية'>أطلب الان</Link>
//                                     </span>
//                                 </div>
//                             </div>
//                         </div>
//                         <div className="services-name">
//                             <div className='najiz-service' ref={(el) => addToRefs(el, 5)}>
//                                 <h1>خدمات منصة ناجز</h1>
//                                 <div>
//                                     <span><Link to='/services/najizServices'>التفاصيل</Link></span>
//                                     <span><img loading='lazy' src={watsIcon} alt="Icon" /> &nbsp;
//                                         <Link to='https://wa.me/+966561103887?text=السلام عليكم. اريد استفسر عن خدمات منصة ناجز'>أطلب الان</Link>
//                                     </span>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </SwiperSlide>
//                 <SwiperSlide>
//                     <div>
//                         <div className="services-name">
//                             <div className='madad-service' ref={(el) => addToRefs(el, 6)}>
//                                 <h1>خدمات منصة مدد</h1>
//                                 <div>
//                                     <span><Link to='/services/madad'>التفاصيل</Link></span>
//                                     <span><img loading='lazy' src={watsIcon} alt="Icon" /> &nbsp;
//                                         <Link to='https://wa.me/+966561103887?text=السلام عليكم اريد استفسر عن خدمات منصة مدد'>أطلب الان</Link>
//                                     </span>
//                                 </div>
//                             </div>
//                         </div>
//                         <div className="services-name">
//                             <div className='civil-defense' ref={(el) => addToRefs(el, 7)}>
//                                 <h1>خدمات الدفاع المدني</h1>
//                                 <div>
//                                     <span><Link to="/services/civilservices">التفاصل</Link></span>
//                                     <span><img loading='lazy' src={watsIcon} alt="Icon" /> &nbsp;
//                                         <Link to='https://wa.me/+966561103887?text=السلام عليكم. لدي استفسار عن خدمات الدفاع المدني'>أطلب الان</Link>
//                                     </span>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </SwiperSlide>

//                 <SwiperSlide>
//                     <div>
//                         <div className="services-name">
//                             <div className={`${styleCompanys.back1} service-item`} ref={(el) => addToRefs(el, 8)}>
//                                 <h1>الترخيص المهني</h1>
//                                 <div>
//                                     <span><Link to='/services/professionallicense'>التفاصيل</Link></span>
//                                     <span><img loading='lazy' src={watsIcon} alt="Icon" /> &nbsp;
//                                         <Link to='https://wa.me/+966509150333?text=السلام عليكم. اريد استفسر عن ترخيص مهني'>أطلب الان</Link>
//                                     </span>
//                                 </div>
//                             </div>

//                         </div>
//                         <div className="services-name">
//                             <div className={`${styleCompanys.back2} service-item`} ref={(el) => addToRefs(el, 9)}>
//                                 <h1>الترخيص الزراعي</h1>
//                                 <div>
//                                     <span><Link to='/services/agriculturallicense'>التفاصيل</Link></span>
//                                     <span><img loading='lazy' src={watsIcon} alt="Icon" /> &nbsp;
//                                         <Link to='https://wa.me/+966509150333?text=السلام عليكم. اريد استفسر عن ترخيص زراعي'>أطلب الان</Link>
//                                     </span>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </SwiperSlide>

//                 <SwiperSlide>
//                     <div>
//                         <div className="services-name">
//                             <div className={`${styleCompanys.back3} service-item`} ref={(el) => addToRefs(el, 10)}>
//                                 <h1>ترخيص تجاري اجنبي</h1>
//                                 <div>
//                                     <span><Link to='/services/forecommlice'>التفاصيل</Link></span>
//                                     <span><img loading='lazy' src={watsIcon} alt="Icon" /> &nbsp;
//                                         <Link to='https://wa.me/+966509150333?text=السلام عليكم. اريد استفسر عن ترخيص تجاري اجنبي'>أطلب الان</Link>
//                                     </span>
//                                 </div>
//                             </div>
//                         </div>
//                         <div className="services-name">
//                             <div className={`${styleCompanys.back4} service-item`} ref={(el) => addToRefs(el, 11)}>
//                                 <h1>ترخيص تجاري بشريك سعودي</h1>
//                                 <div>
//                                     <span><Link to='/services/coiLissauPar'>التفاصيل</Link></span>
//                                     <span><img loading='lazy' src={watsIcon} alt="Icon" /> &nbsp;
//                                         <Link to='https://wa.me/+966509150333?text=السلام عليكم. اريد استفسر عن ترخيص تجاري بشريك سعودي'>أطلب الان</Link>
//                                     </span>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </SwiperSlide>

//                 <SwiperSlide>
//                     <div>
//                         <div className="services-name">

//                             <div className={`${styleCompanys.back5} service-item`} ref={(el) => addToRefs(el, 12)}>
//                                 <h1>الترخيص المهني بشريك سعودي</h1>
//                                 <div>
//                                     <span><Link to='/services/proflicesapartner'>التفاصيل</Link></span>
//                                     <span><img loading='lazy' src={watsIcon} alt="Icon" /> &nbsp;
//                                         <Link to='https://wa.me/+966509150333?text=السلام عليكم. اريد استفسر عن ترخيص مهني بشريك سعودي'>أطلب الان</Link>
//                                     </span>
//                                 </div>
//                             </div>
//                         </div>

//                         <div className="services-name">
//                             <div className={`${styleCompanys.back6} service-item`} ref={(el) => addToRefs(el, 13)}>
//                                 <h1>ترخيص أنشطة النقل</h1>
//                                 <div>
//                                     <span><Link to='/services/transactivlice'>التفاصيل</Link></span>
//                                     <span><img loading='lazy' src={watsIcon} alt="Icon" /> &nbsp;
//                                         <Link to='https://wa.me/+966509150333?text=السلام عليكم. اريد استفسر عن ترخيص نشاط نقل'>أطلب الان</Link>
//                                     </span>
//                                 </div>
//                             </div>

//                         </div>
//                     </div>
//                 </SwiperSlide>
//                 <SwiperSlide>
//                     <div>
//                         <div className="services-name">

//                             <div className={`${styleCompanys.back7} service-item`} ref={(el) => addToRefs(el, 14)}>
//                                 <h1>الترخيص العقاري</h1>
//                                 <div>
//                                     <span><Link to='/services/prolic'>التفاصيل</Link></span>
//                                     <span><img loading='lazy' src={watsIcon} alt="Icon" /> &nbsp;
//                                         <Link to='https://wa.me/+966509150333?text=السلام عليكم. اريد استفسر عن ترخيص عقاري'>أطلب الان</Link>
//                                     </span>
//                                 </div>
//                             </div>
//                         </div>

//                         <div className="services-name">

//                             <div className={`${styleCompanys.back8} service-item`} ref={(el) => addToRefs(el, 15)}>
//                                 <h1>ترخيص صناعي</h1>
//                                 <div>
//                                     <span><Link to='/services/indlic'>التفاصيل</Link></span>
//                                     <span><img loading='lazy' src={watsIcon} alt="Icon" /> &nbsp;
//                                         <Link to='https://wa.me/+966509150333?text=السلام عليكم. اريد استفسر عن ترخيص صناعي'>أطلب الان</Link>
//                                     </span>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </SwiperSlide>
//                 <SwiperSlide>
//                     <div>
//                         <div className="services-name">
//                             <div className={`${stylePrem.back1} service-item`} ref={(el) => addToRefs(el, 16)}>
//                                 <h1>إقامة مستثمر أعمال</h1>
//                                 <div>
//                                     <span><Link to='/services/invbizres'>التفاصيل</Link></span>
//                                     <span><img loading='lazy' src={watsIcon} alt="Icon" /> &nbsp;
//                                         <Link to='https://wa.me/+966509150333?text=السلام عليكم. اريد استفسر عن إقامة مستثمر أعمال'>أطلب الان</Link>
//                                     </span>
//                                 </div>
//                             </div>
//                         </div>
//                         <div className="services-name">
//                             <div className={`${stylePrem.back2} service-item`} ref={(el) => addToRefs(el, 17)}>
//                                 <h1>إقامة مميزة غير محددة المدة ومحددة المدة</h1>
//                                 <div>
//                                     <span><Link to='/services/unires'>التفاصيل</Link></span>
//                                     <span><img loading='lazy' src={watsIcon} alt="Icon" /> &nbsp;
//                                         <Link to='https://wa.me/+966509150333?text=السلام عليكم. اريد استفسر عن إقامة مميز'>أطلب الان</Link>
//                                     </span>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </SwiperSlide>
//                 <SwiperSlide>
//                     <div>
//                         <div className="services-name">
//                             <div className={`${stylePrem.back3} service-item`} ref={(el) => addToRefs(el, 18)}>
//                                 <h1>إقامة رائدة أعمال</h1>
//                                 <div>
//                                     <span><Link to='/services/entres'>التفاصيل</Link></span>
//                                     <span><img loading='lazy' src={watsIcon} alt="Icon" /> &nbsp;
//                                         <Link to='https://wa.me/+966509150333?text=السلام عليكم. استفسار عن إقامة رائد اعمال'>أطلب الان</Link>
//                                     </span>
//                                 </div>
//                             </div>
//                         </div>
//                         <div className="services-name">
//                             <div className={`${stylePrem.back4} service-item`} ref={(el) => addToRefs(el, 19)}>
//                                 <h1>إقامة مالك عقار</h1>
//                                 <div>
//                                     <span><Link to='/services/proownres'>التفاصيل</Link></span>
//                                     <span><img loading='lazy' src={watsIcon} alt="Icon" /> &nbsp;
//                                         <Link to='https://wa.me/+966509150333?text=السلام عليكم. استفسار عن إقامة مالك عقار'>أطلب الان</Link>
//                                     </span>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </SwiperSlide>
//                 <SwiperSlide>
//                     <div>
//                         <div className="services-name">
//                             <div className={`${stylePrem.back5} service-item`} ref={(el) => addToRefs(el, 20)}>
//                                 <h1>إقامة الموهبة</h1>
//                                 <div>
//                                     <span><Link to='/services/talres'>التفاصيل</Link></span>
//                                     <span><img loading='lazy' src={watsIcon} alt="Icon" /> &nbsp;
//                                         <Link to='https://wa.me/+966509150333?text=السلام عليكم. استفسار عن إقامة الموهبة'>أطلب الان</Link>
//                                     </span>
//                                 </div>
//                             </div>
//                         </div>

//                         <div className="services-name">
//                             <div className={`${stylePrem.back6} service-item`} ref={(el) => addToRefs(el, 21)}>
//                                 <h1>إقامة الكفائة الاستثنائية</h1>
//                                 <div>
//                                     <span><Link to='/services/excepres'>التفاصيل</Link></span>
//                                     <span><img loading='lazy' src={watsIcon} alt="Icon" /> &nbsp;
//                                         <Link to='https://wa.me/+966509150333?text=السلام عليكم. اريد استفسر عن إقامة الكفائة الاستثنائية'>أطلب الان</Link>
//                                     </span>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </SwiperSlide>
//                 <SwiperSlide>
//                     <div>
//                         <div className="services-name">
//                             <div className={`${styleMark.back1} service-item`} ref={(el) => addToRefs(el, 22)}>
//                                 <h1>إدراة وتنظيم الحفلات والمؤتمرات</h1>
//                                 <div>
//                                     <span><Link to='/services/manorgevCon'>التفاصيل</Link></span>
//                                     <span><img loading='lazy' src={watsIcon} alt="Icon" /> &nbsp;
//                                         <Link to='https://wa.me/+966531906999?text=السلام عليكم. اريد استفسر عن تنظيم حفلات و مؤتمرات'>أطلب الان</Link>
//                                     </span>
//                                 </div>
//                             </div>
//                         </div>
//                         <div className="services-name">
//                             <div className={`${styleMark.back2} service-item`} ref={(el) => addToRefs(el, 23)}>
//                                 <h1>تفعيل تابي وتمارا</h1>
//                                 <div>
//                                     <span><Link to='/services/actTabtam'>التفاصيل</Link></span>
//                                     <span><img loading='lazy' src={watsIcon} alt="Icon" /> &nbsp;
//                                         <Link to='https://wa.me/+966531906999?text=السلام عليكم. اريد استفسر عن تفعيل تابي وتمارا'>أطلب الان</Link>
//                                     </span>
//                                 </div>
//                             </div>

//                         </div>
//                     </div>
//                 </SwiperSlide>

//                 <SwiperSlide>
//                     <div>
//                         <div className="services-name">
//                             <div className={`${styleMark.back3} service-item`} ref={(el) => addToRefs(el, 24)}>
//                                 <h1>تطوير صفحات الويب</h1>
//                                 <div>
//                                     <span><Link to='/services/devweb'>التفاصيل</Link></span>
//                                     <span><img loading='lazy' src={watsIcon} alt="Icon" /> &nbsp;
//                                         <Link to='https://wa.me/+966531906999?text=السلام عليكم. اريد استفسر عن تطوير صفحات الويب'>أطلب الان</Link>
//                                     </span>
//                                 </div>
//                             </div>

//                         </div>

//                         <div className="services-name">
//                             <div className={`${styleMark.back4} service-item`} ref={(el) => addToRefs(el, 25)}>
//                                 <h1>رفع جوجل ماب</h1>
//                                 <div>
//                                     <span><Link to='/services/upmap'>التفاصيل</Link></span>
//                                     <span><img loading='lazy' src={watsIcon} alt="Icon" /> &nbsp;
//                                         <Link to='https://wa.me/+966531906999?text=السلام عليكم. اريد استفسر عن رفع جوجل ماب'>أطلب الان</Link>
//                                     </span>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </SwiperSlide>
//                 <SwiperSlide>
//                     <div>
//                         <div className="services-name">
//                             <div className={`${styleMark.back5} service-item`} ref={(el) => addToRefs(el, 26)}>
//                                 <h1>رفع العلامات التجارية</h1>
//                                 <div>
//                                     <span><Link to='/services/raibra'>التفاصيل</Link></span>
//                                     <span><img loading='lazy' src={watsIcon} alt="Icon" /> &nbsp;
//                                         <Link to='https://wa.me/+966531906999?text=السلام عليكم. اريد استفسر عن رفع العلامة التجارية'>أطلب الان</Link>
//                                     </span>
//                                 </div>
//                             </div>
//                         </div>
//                         <div className="services-name">
//                             <div className={`${styleMark.back6} service-item`} ref={(el) => addToRefs(el, 27)}>
//                                 <h1>إدارة وتنظيم المتاجر الالكترونية</h1>
//                                 <div>
//                                     <span><Link to='/services/manorgEst'>التفاصيل</Link></span>
//                                     <span><img loading='lazy' src={watsIcon} alt="Icon" /> &nbsp;
//                                         <Link to='https://wa.me/+966531906999?text=السلام عليكم اريد استفسر عن إدارة المتاجر الالكترونية'>أطلب الان</Link>
//                                     </span>
//                                 </div>
//                             </div>
//                         </div>

//                     </div>
//                 </SwiperSlide>

//                 <SwiperSlide>
//                     <div>
//                         <div className="services-name">
//                             <div className={`${styleMark.back7} service-item`} ref={(el) => addToRefs(el, 28)}>
//                                 <h1>إدارة حسابات السوشيال ميديا</h1>
//                                 <div>
//                                     <span><Link to='/services/mansocacc'>التفاصيل</Link></span>
//                                     <span><img loading='lazy' src={watsIcon} alt="Icon" /> &nbsp;
//                                         <Link to='https://wa.me/+966531906999?text=السلام عليكم. اريد استفسر عن إدارة حسابات السوشيال ميديا'>أطلب الان</Link>
//                                     </span>
//                                 </div>
//                             </div>
//                         </div>
//                         <div className="services-name">
//                             <div className={`${styleMark.back8} service-item`} ref={(el) => addToRefs(el, 29)}>
//                                 <h1>تصوير المنتجات</h1>
//                                 <div>
//                                     <span><Link to='/services/propho'>التفاصيل</Link></span>
//                                     <span><img loading='lazy' src={watsIcon} alt="Icon" /> &nbsp;
//                                         <Link to='https://wa.me/+966531906999?text=السلام عليكم. اريد استفسر عن تصوير المنتجات'>أطلب الان</Link>
//                                     </span>
//                                 </div>
//                             </div>
//                         </div>

//                     </div>
//                 </SwiperSlide>
//                 <SwiperSlide>
//                     <div>
//                         <div className="services-name">
//                             <div className={`${styleAcc.back1} service-item`} ref={(el) => addToRefs(el, 30)}>
//                                 <h1>مسك الدفاتر المحاسبية</h1>
//                                 <div>
//                                     <span><Link to='/services/booAccrec'>التفاصيل</Link></span>
//                                     <span><img loading='lazy' src={watsIcon} alt="Icon" /> &nbsp;
//                                         <Link to='https://wa.me/+966564716444?text=السلام عليكم. عندي استفسار عن الدفاتر المحاسبية'>أطلب الان</Link>
//                                     </span>
//                                 </div>
//                             </div>
//                         </div>
//                         <div className="services-name">
//                             <div className={`${styleAcc.back2} service-item`} ref={(el) => addToRefs(el, 31)}>
//                                 <h1>التهيئة والتدريب على الأنظمة المحاسبية</h1>
//                                 <div>
//                                     <span><Link to='/services/settraacc'>التفاصيل</Link></span>
//                                     <span><img loading='lazy' src={watsIcon} alt="Icon" /> &nbsp;
//                                         <Link to='https://wa.me/+966564716444?text=السلام عليكم. عندي استفسار عن التدريب على الانظمة المحاسبية'>أطلب الان</Link>
//                                     </span>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </SwiperSlide>

//                 <SwiperSlide>
//                     <div>
//                         <div className="services-name">
//                             <div className={`${styleAcc.back3} service-item`} ref={(el) => addToRefs(el, 32)}>
//                                 <h1>فحص اداء الأنظمة المحاسبية</h1>
//                                 <div>
//                                     <span><Link to='/services/accsysper'>التفاصيل</Link></span>
//                                     <span><img loading='lazy' src={watsIcon} alt="Icon" /> &nbsp;
//                                         <Link to='https://wa.me/+966564716444?text=السلام عليكم. اريد استفسر عن فحص اداء الانظمة  المحاسبية'>أطلب الان</Link>
//                                     </span>
//                                 </div>
//                             </div>
//                         </div>
//                         <div className="services-name">
//                             <div className={`${styleAcc.back4} service-item`} ref={(el) => addToRefs(el, 33)}>
//                                 <h1>إدارة المخازن والجرد</h1>
//                                 <div>
//                                     <span><Link to='/services/warinvman'>التفاصيل</Link></span>
//                                     <span><img loading='lazy' src={watsIcon} alt="Icon" /> &nbsp;
//                                         <Link to='https://wa.me/+966564716444?text=السلام عليكم. اريد استفسر عن إدارة المخازن والجرد'>أطلب الان</Link>
//                                     </span>
//                                 </div>
//                             </div>
//                         </div>

//                     </div>
//                 </SwiperSlide>

//                 <SwiperSlide>
//                     <div>
//                         <div className="services-name">
//                             <div className={`${styleAcc.back5} service-item`} ref={(el) => addToRefs(el, 34)}>
//                                 <h1>تقديم إستشارات محاسبية</h1>
//                                 <div>
//                                     <span><Link to='/services/proacccon'>التفاصيل</Link></span>
//                                     <span><img loading='lazy' src={watsIcon} alt="Icon" /> &nbsp;
//                                         <Link to='https://wa.me/+966564716444?text=السلام عليكم. اريد استشارة محاسبية'>أطلب الان</Link>
//                                     </span>
//                                 </div>
//                             </div>
//                         </div>

//                     <div className="services-name">
//                         <div className={`${styleAcc.back6} service-item`} ref={(el) => addToRefs(el, 35)}>
//                             <h1>تزويد المنشأة بالانظمة المحاسبية بما يتناسب مع احتياجات النشاط</h1>
//                             <div>
//                                 <span><Link to='/services/proaccsys'>التفاصيل</Link></span>
//                                 <span><img loading='lazy' src={watsIcon} alt="Icon" /> &nbsp;
//                                     <Link to='https://wa.me/+966564716444?text=السلام عليكم. اريد نظام محاسبي'>أطلب الان</Link>
//                                 </span>
//                             </div>
//                         </div>
//                     </div>
//                     </div>
//                 </SwiperSlide>

//                 <SwiperSlide>
//                     <div>
//                         <div className="services-name">
//                             <div className={`${styleAcc.back7} service-item`} ref={(el) => addToRefs(el, 36)}>
//                                 <h1>إعداد القرارات الضريبية</h1>
//                                 <div>
//                                     <span><Link to='/services/pretaxdec'>التفاصيل</Link></span>
//                                     <span><img loading='lazy' src={watsIcon} alt="Icon" /> &nbsp;
//                                         <Link to='https://wa.me/+966564716444?text=السلام عليكم. اريد استفسر عن إعداد القرارات الضريبية'>أطلب الان</Link>
//                                     </span>
//                                 </div>
//                             </div>
//                         </div>
//                         <div className="services-name">
//                             <div className={`${styleAcc.back8} service-item`} ref={(el) => addToRefs(el, 37)}>
//                                 <h1>إعداد التقارير المالية والإدارية والختامية</h1>
//                                 <div>
//                                     <span><Link to='/services/prefinadmfin'>التفاصيل</Link></span>
//                                     <span><img loading='lazy' src={watsIcon} alt="Icon" /> &nbsp;
//                                         <Link to='https://wa.me/+966564716444?text=السلام عليكم. اريد استفسر عن إعداد التقارير المالية والادارية'>أطلب الان</Link>
//                                     </span>
//                                 </div>
//                             </div>
//                         </div>

//                     </div>
//                 </SwiperSlide>
//                 <SwiperSlide>
//                     <div>
//                         <div className="services-name">
//                             <div className={`${styleProg.back1} service-item`} ref={(el) => addToRefs(el, 38)}>
//                                 <h1>تطبيقات</h1>
//                                 <div>
//                                     <span><Link to='/services/appDev'>التفاصيل</Link></span>
//                                     <span><img loading='lazy' src={watsIcon} alt="Icon" /> &nbsp;
//                                         <Link to='https://wa.me/+966554069111?text=السلام عليكم. عندي استفسار في مجال التطبيقات'>أطلب الان</Link>
//                                     </span>
//                                 </div>
//                             </div>
//                         </div>

//                         <div className="services-name">
//                             <div className={`${styleProg.back2} service-item`} ref={(el) => addToRefs(el, 39)}>
//                                 <h1>مواقع الكترونية</h1>
//                                 <div>
//                                     <span><Link to='/services/web'>التفاصيل</Link></span>
//                                     <span><img loading='lazy' src={watsIcon} alt="Icon" /> &nbsp;
//                                         <Link to='https://wa.me/+966554069111?text=السلام عليكم. عندي استفسار في مجال المواقع الالكترونية'>أطلب الان</Link>
//                                     </span>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </SwiperSlide>

//                 <SwiperSlide>
//                     <div>
//                         <div className="services-name">
//                             <div className={`${styleProg.back3} service-item`} ref={(el) => addToRefs(el, 40)}>
//                                 <h1>الدعم الفني</h1>
//                                 <div>
//                                     <span><Link to='/services/technicSupport'>التفاصيل</Link></span>
//                                     <span><img loading='lazy' src={watsIcon} alt="Icon" /> &nbsp;
//                                         <Link to='https://wa.me/+966554069111?text=السلام عليكم. اريد دعم فني'>أطلب الان</Link>
//                                     </span>
//                                 </div>
//                             </div>
//                         </div>

//                         <div className="services-name">
//                             <div className={`${styleProg.back4} service-item`} ref={(el) => addToRefs(el, 41)}>
//                                 <h1>نظام الموارد البشرية</h1>
//                                 <div>
//                                     <span><Link to='/services/hr'>التفاصيل</Link></span>
//                                     <span><img loading='lazy' src={watsIcon} alt="Icon" /> &nbsp;
//                                         <Link to='https://wa.me/+966554069111?text=السلام عليكم. اريد استفسر عن نظام الموارد البشرية'>أطلب الان</Link>
//                                     </span>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </SwiperSlide>


//                 <SwiperSlide>
//                     <div>
//                         <div className="services-name">
//                             <div className={`${styleProg.back5} service-item`} ref={(el) => addToRefs(el, 42)}>
//                                 <h1>نظام المحاسبة</h1>
//                                 <div>
//                                     <span><Link to='/services/accountSys'>التفاصيل</Link></span>
//                                     <span><img loading='lazy' src={watsIcon} alt="Icon" /> &nbsp;
//                                         <Link to='https://wa.me/+966554069111?text=السلام عليكم. عندي استفسار في النظام المحاسبي'>أطلب الان</Link>
//                                     </span>
//                                 </div>
//                             </div>
//                         </div>
//                     <div className="services-name">
//                         <div className={`${styleProg.back6} service-item`} ref={(el) => addToRefs(el, 43)}>
//                             <h1>نظام إداري</h1>
//                             <div>
//                                     <span><Link to='/services/AdminSystem'>التفاصيل</Link></span>
//                                 <span><img loading='lazy' src={watsIcon} alt="Icon" /> &nbsp;
//                                     <Link to='https://wa.me/+966554069111?text=السلام عليكم. اريد استفسر في النظام الاداري'>أطلب الان</Link>
//                                 </span>
//                             </div>
//                         </div>
//                     </div>
//                     </div>
//                 </SwiperSlide>

//                 <SwiperSlide>
//                     <div className="services-name">
//                         <div className={`${styleProg.back7} service-item`} ref={(el) => addToRefs(el, 44)}>
//                             <h1>نظام CRM</h1>
//                             <div>
//                                 <span><Link to='/services/crm'>التفاصيل</Link></span>
//                                 <span><img loading='lazy' src={watsIcon} alt="Icon" /> &nbsp;
//                                     <Link to='https://wa.me/+966554069111?text=السلام عليكم. اريد استفسر عن نظام ال crm'>أطلب الان</Link>
//                                 </span>
//                             </div>
//                         </div>
//                     </div>
//                 </SwiperSlide>
//             </Swiper>
//         </div>
//     )
// }

// export default AllServices





import React, { useEffect, useRef } from 'react'
import watsIcon from '../assest/home/5357b4eb16238760df0ba166628f1cee41086e44.png';
import { Link } from 'react-router-dom';
// Import Swiper ومكوناته
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { servicesData } from '../data/servicesData';

function AllServices() {
    const serviceRefs = useRef([]);

    useEffect(() => {
        try {
            const observer = new IntersectionObserver(
                (entries) => {
                    entries.forEach((entry) => {
                        if (entry.isIntersecting) {
                            entry.target.classList.add('animate-in');
                            observer.unobserve(entry.target);
                        }
                    });
                },
                {
                    threshold: 0.1,
                    rootMargin: '0px 0px -50px 0px'
                }
            );

            serviceRefs.current.forEach((ref) => {
                if (ref) observer.observe(ref);
            });

            return () => {
                serviceRefs.current.forEach((ref) => {
                    if (ref) observer.unobserve(ref);
                });
            };
        } catch (err) {
            console.log(err,'allservices')
        }
    }, []);

    const addToRefs = (el, index) => {
        try {
            if (el && !serviceRefs.current.includes(el)) {
                serviceRefs.current[index] = el;
            }
        } catch (err) {
            console.log(err,'allservices')
        }
    };

    // دالة لعرض رابط التفاصيل بناءً على النوع
    const renderDetailsLink = (service) => {
        switch (service.detailsType) {
            case 'link':
                return <Link to={service.detailsLink}>التفاصيل</Link>;
            case 'span-link':
                return <span><Link to={service.detailsLink}>التفاصيل</Link></span>;
            case 'span-text':
                return <span>{service.detailsText}</span>;
            default:
                return <Link to={service.detailsLink}>التفاصيل</Link>;
        }
    };

    return (
        <div className="services-container">
            <Swiper
                modules={[Autoplay, Pagination, Navigation]}
                spaceBetween={20}
                slidesPerView={1}
                autoplay={{
                    delay: 3000,
                    disableOnInteraction: false,
                }}
                pagination={{
                    clickable: true,
                }}
                navigation={{
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                }}
                breakpoints={{
                    640: { slidesPerView: 2 },
                    768: { slidesPerView: 3 },
                    1024: { slidesPerView: 4 }
                }}
            >
                {/* أزرار التنقل */}
                <div className="swiper-button-prev"></div>
                <div className="swiper-button-next"></div>

                {servicesData.map((group) => (
                    <SwiperSlide key={group.id}>
                        <div>
                            {group.services.map((service) => (
                                <div className="services-name" key={service.id}>
                                    <div 
                                        className={service.className}
                                        ref={(el) => addToRefs(el, service.id)}
                                    >
                                        <h1>{service.name}</h1>
                                        <div>
                                            {renderDetailsLink(service)}
                                            <span>
                                                <img loading='lazy' src={watsIcon} alt="Icon" /> &nbsp;
                                                <Link to={service.whatsappLink}>أطلب الان</Link>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    )
}

export default AllServices